import { render } from "./ProposalEmailSettings.vue?vue&type=template&id=5dfd852e"
import script from "./ProposalEmailSettings.vue?vue&type=script&lang=js"
export * from "./ProposalEmailSettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__